import { login } from "@lib/data/customer";
import { LOGIN_VIEW } from "@modules/account/templates/login-template";
import ErrorMessage from "@modules/checkout/components/error-message";
import Input from "@modules/common/components/input";
import ButtonCustom from "@modules/layout/components/button-custom";
import { useParams } from "next/navigation";
import { useState } from "react";

type Props = {
  setCurrentView: (view: LOGIN_VIEW) => void;
};

const Login = ({ setCurrentView }: Props) => {
  const [message, setMessage] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const { countryCode } = useParams() as { countryCode: string };

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);

    const formData = new FormData(event.currentTarget);
    const error = await login(null, formData, countryCode);

    if (error) setMessage(error);
    setLoading(false);
  };

  return (
    <div className="max-w-sm flex flex-col items-center gap-4" data-testid="login-page">
      <h1 className="text-large-semi uppercase">Đăng nhập tài khoản</h1>
      <p className="text-center text-base-regular text-ui-fg-base">
        <span className="text-center text-ui-fg-base text-small-regular mt-6">
          Bạn chưa có tài khoản?{" "}
          <button
            onClick={() => setCurrentView(LOGIN_VIEW.REGISTER)}
            className="text-primary-500"
            data-testid="register-button"
          >
            Đăng ký tại đây
          </button>
        </span>
      </p>
      <form className="max-w-full" onSubmit={handleSubmit}>
        <div className="flex flex-col w-[250px] sm:w-[300px] gap-y-2">
          <Input
            label="Email"
            name="email"
            type="email"
            title="Enter a valid email address."
            autoComplete="email"
            required
            data-testid="email-input"
          />
          <Input
            label="Mật khẩu"
            name="password"
            type="password"
            autoComplete="current-password"
            required
            data-testid="password-input"
          />
        </div>
        <ErrorMessage error={message} data-testid="login-error-message" />
        <ButtonCustom data-testid="sign-in-button" className="w-full mt-6" type="submit" disabled={loading}>
          {loading ? "Đang đăng nhập..." : "Đăng nhập"}
        </ButtonCustom>
      </form>
    </div>
  );
};

export default Login;
